import AppTopbar from "../Components/AppTopbar";
import { useTranslation } from "react-i18next";
import dbservice from "../Utility/DbConnection/dbservice.js";
import { TransformIntSQLDate } from "../Utility/Utility";

import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";

import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import SearchPanelComponent from "../Components/Panels/SearchPanelComponent";
import { Image } from "primereact/image";
import dbManagerInterface from "../Utility/DbConnection/DBManagerInterface.js";
import PieceImageDialog from "../Components/Dialogs/PieceImageDialog.js";
import { Panel } from "primereact/panel";
import { useNavigate } from "react-router-dom";
import SPCDialog from "../Components/Dialogs/SPCDialog.js";

const route = "Automata/EndProcess/";
const idValueName = "ID";

function EndProcessDataPage() {
  const type = "endprocess";
  const navigate = useNavigate();
  const toast = useRef(null);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [topNumber, setTopNumber] = useState(30);
  const [endProcessMetadata, setEndProcessMetadata] = useState(null);
  const [selectedEndProcess, setSelectedEndProcess] = useState(null);
  const [selectedMeasures, setSelectedMeasures] = useState(null);
  const [endProcessData, setEndProcessData] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [idValue, setIdValue] = useState(null);

  const [loading, setLoading] = useState(false);
  const [isDataPresent, setIsDataPresent] = useState(false);
  const [columns, setColumns] = useState(false);

  const [imageDialogVisible, setImageDialogVisible] = useState(false);
  const [imagePieceId, setImagePieceId] = useState(null);
  const [whereMeasures, setWhereMeasures] = useState(null);

  const [client, setClient] = useState(null);
  const [plant, setPlant] = useState(null);
  const [clientPlant, setClientPlant] = useState(null);

  const [spcVisible, setSpcVisible] = useState(false);

  const rowFiltersString =
    process.env.REACT_APP_ENDPROCESS_MEASURES_FILTER || "";

  useEffect(() => {
    setLoading(true);
    const sessionClient = sessionStorage.getItem("chosenClient");
    const sessionPlant = sessionStorage.getItem("chosenPlant");
    setClient(sessionClient);
    setPlant(sessionPlant);
    setClientPlant(sessionClient + "-" + sessionPlant);
    setLoading(false);
  }, []); // Dependency array is empty, so it runs only on mount

  useEffect(() => {
    if (endProcessMetadata && selectedMeasures) {
      // onSearchClick();
      // const actualDate = new Date();
      // setEndDate(actualDate);
      // const actualDateMinusOneDay = new Date(
      //   actualDate.getTime() - 24 * 60 * 60 * 1000
      // );
      // setStartDate(actualDateMinusOneDay);
    }
  }, [endProcessMetadata, selectedMeasures]);

  const onSearchClick = () => {
    setLoading(true);
    console.log(startDate, endDate, selectedMachine, selectedMeasures);
    const startDateSQL = TransformIntSQLDate(startDate);
    const endDateSQL = TransformIntSQLDate(endDate);

    if (startDate > endDate) {
      console.log("Start Date is greater than End Date");
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("error1"),
        life: 3000,
      });
    }
    const machineMeasures = {};
    let machinesToSend = selectedMachine.map((machine) => machine.Machine);
    if (selectedMeasures) {
      // I will send only the machines included by the measures
      const machinesToSend = new Set();

      Object.keys(selectedMeasures).forEach((key) => {
        if (!key.includes("-")) return; // Skip if it's just the machine name

        const [machineName, measure] = key.split("-", 2); // Split into machine name and measure name

        if (!machineMeasures[machineName]) {
          machineMeasures[machineName] = [];
        }
        machineMeasures[machineName].push(measure);
        machinesToSend.add(machineName); // Use a Set to avoid duplicates
      });
      // //i filter also metadata to pass to chart
      // const filteredMetadata = measuresMetadata.filter(
      //     metadata => measures.includes(metadata.Name)
      // );
      // console.log("filteredMetadata", filteredMetadata)
    }

    let whereMeasuresDictionary = {};
    if (whereMeasures) {
      whereMeasuresDictionary = whereMeasures;
    }

    const body = {
      Machines: machinesToSend,
      DateStart: startDateSQL,
      DateEnd: endDateSQL,
      Measures: machineMeasures,
      WhereMeasures: whereMeasuresDictionary,
      Top: topNumber,
      //add also Id here
      [idValueName]: idValue,
    };
    const machine = "null";
    const queryParams = `Client=${client}-${plant}&Machine=${machine}`;
    dbManagerInterface.SendPostRequest(
      route + "GetEndProcess",
      JSON.stringify(body),
      (resData) => {
        if (!resData.success || resData.data?.length === 0) {
          toast.current.show({
            severity: "warn",
            summary: t("warning"),
            detail: t("warning1"),
            life: 3000,
          });
          setIsDataPresent(false);
          setLoading(false);
        } else {
          setEndProcessData(resData.data);
          //sort endProcessData by TS Descending
          resData.data.sort((a, b) => new Date(b.TS) - new Date(a.TS));
          //create columns based on data keys
          const otherColumns = [];
          const tsColumn = []; // Array to store the TS column
          const idColumn = [];
          const filtersColumns = [];
          const columnNames = new Set();
          resData.data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (!columnNames.has(key)) {
                // Check if column name already exists
                columnNames.add(key);
                const columnComponent = (
                  <Column
                    key={key}
                    field={key}
                    header={key.charAt(0).toUpperCase() + key.slice(1)}
                    sortable
                  />
                );
                if (key !== "RowNum" && key !== "SampleTime") {
                  if (key === "TS") {
                    tsColumn.push(columnComponent); // Add TS column to its own array
                  } else {
                    if (key === "ID") {
                      idColumn.push(columnComponent);
                    } else if (
                      rowFiltersString &&
                      rowFiltersString.includes(key)
                    ) {
                      filtersColumns.push(columnComponent);
                    } else {
                      otherColumns.push(columnComponent);
                    } // Add other columns
                  }
                }
              }
            });
          });

          //create the column with the button to open the dialog
          const actionColumn = (
            <Column
              key="action"
              header={t("image")}
              filter
              body={(rowData) => (
                <Button
                  icon="pi pi-image"
                  className="p-button-rounded p-button-info"
                  onClick={() => {
                    setImageDialogVisible(true);
                    setImagePieceId(rowData.Piece_ID); // Assuming 'ID' is the field name for piece ID
                  }}
                />
              )}
            />
          );
          // Combine TS column with other columns, ensuring TS is first
          const combinedColumns = [
            ...tsColumn,
            ...idColumn,
            ...[actionColumn],
            ...filtersColumns,
            ...otherColumns,
          ];

          setColumns(combinedColumns);
          setIsDataPresent(true);
          setLoading(false);
        }
      },
      (error) => {
        console.error("error", error);
        setLoading(false);
      },
      toast.current,
      null,
      queryParams
    );
  };
  const openCurves = () => {
    const ts = selectedEndProcess["TS"]; // e.g. "2025-10-06 15:19:26"
    const totalCycleSeconds = 7200; // in seconds

    // Convert timestamp string to a Date object
    const tsDate = new Date(ts);

    // Compute start and end times in milliseconds
    const dateEnd = new Date(tsDate.getTime() + totalCycleSeconds * 1000);
    const dateStart = new Date(tsDate.getTime() - totalCycleSeconds * 1000);

    // Convert to desired string format
    const formattedStart = dateStart.toString(); // e.g. "Mon Oct 06 2025 09:54:31 GMT+0200 (Ora legale dell’Europa centrale)"
    const formattedEnd = dateEnd.toString();

    navigate("/curves", {
      state: {
        dateStart: formattedStart,
        dateEnd: formattedEnd,
        id: selectedEndProcess["ID"],
      },
    });
  };

  const tableHeader = () => {
    return (
      <div className="flex justify-between">
        <Button
          type="button"
          icon="pi pi-chart-line"
          disabled={!selectedEndProcess || selectedEndProcess == null}
          label={t("openCurves")}
          outlined
          onClick={openCurves}
        />
      </div>
    );
  };

  return (
    <div>
      <AppTopbar title={t("endProcess")} menuCode={6} />
      <Toast ref={toast} />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SearchPanelComponent
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          topNumber={topNumber}
          setTopNumber={setTopNumber}
          type={type}
          idValue={idValue}
          setIdValue={setIdValue}
          selectedMachine={selectedMachine}
          setSelectedMachine={setSelectedMachine}
          setSelectedMeasures={setSelectedMeasures}
          selectedMeasures={selectedMeasures}
          setMeasuresMetadata={setEndProcessMetadata}
          measuresMetadata={endProcessMetadata}
          onSearchClick={onSearchClick}
          tableData={endProcessData}
          whereMeasures={whereMeasures}
          setWhereMeasures={setWhereMeasures}
        />

        <Panel>
          <div
            style={{
              display: isDataPresent ? "block" : "none",
              width: "100%",
              overflowX: "auto",
            }}
          >
            <DataTable
              header={tableHeader}
              onSelectionChange={(e) => {
                setSelectedEndProcess(e.value);
              }}
              value={endProcessData}
              stripedRows
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 50]}
              filter
              selection={selectedEndProcess}
              selectionMode="single"
              dataKey="TS"
            >
              {columns}
            </DataTable>
          </div>

          <div
            style={{
              display: loading ? "block" : "none",
            }}
          >
            <Image
              src={"/pms/loading.gif"}
              alt={"loading"}
              style={{ display: loading ? "block" : "none" }}
            ></Image>
          </div>

          <div
            style={{
              display: !isDataPresent && !loading ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              margin: "1%",
              textAlign: "center",
            }}
          >
            <h1 style={{ marginBottom: "1rem" }}>{t("noData")}</h1>
            <Image
              src={"/pms/no_data.gif"}
              alt={"no_data"}
              style={{ maxWidth: "300px", height: "450px", width: "100%" }}
            />
          </div>

          <PieceImageDialog
            visible={imageDialogVisible}
            onHide={() => setImageDialogVisible(false)}
            pieceId={imagePieceId}
            client={clientPlant} //TBD get from config
            machine={
              selectedMachine && selectedMachine.length > 0
                ? selectedMachine[0].Machine
                : null
            }
          />
        </Panel>
      </div>
    </div>
  );
}

export default EndProcessDataPage;
